(function () {
    'use strict';

    /*
     * Copyright (c) 2017-19 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('CampaignPrescriptionsCtrl', CampaignPrescriptionsCtrl);

    CampaignPrescriptionsCtrl.$inject = ['I18nService', '$rootScope', '$scope', '$routeParams', 'RxExUtilities', 'RestResources',
        'CampaignConstants', 'CampaignPrescriptionsService', '_', 'ObserverService', 'Frequencies',
        'Utilities', 'PrescriptionChooserConfig', 'IhhModalItemChooser', 'EpisodeTemplatesService',
        'EpisodeTemplateService', 'SortableHelper', 'AdditionalPlaceholderClasses', 'DragCheckerSvc'];

    function CampaignPrescriptionsCtrl (I18nService, $rootScope, $scope, $routeParams, RxExUtilities, RestResources,
        CampaignConstants, CampaignPrescriptionsService, _, ObserverService, Frequencies,
        Utilities, PrescriptionChooserConfig, IhhModalItemChooser, EpisodeTemplatesService,
        EpisodeTemplateService, SortableHelper, AdditionalPlaceholderClasses, DragCheckerSvc) {
        var vm = this;
        var campaignId = $routeParams.campaignId;
        var dragChecker = new DragCheckerSvc.getInstance('.prescriptionTemplates', '.ihh-item-source');

        vm.i18n = I18nService;

        vm.quantityTypes = RxExUtilities.getQuantityTypes();

        vm.prescriptions = [];
        vm.addNewPrescription = addNewPrescription;
        vm.canAddNewPrescription = canAddNewPrescription;
        vm.isEdit = false;
        vm.campaignExercisesConfig;
        vm.campaignExerciseTemplateExercisesConfig;
        vm.tabState;
        vm.setActiveConfig = setActiveConfig;
        vm.isEditMode = CampaignPrescriptionsService.isEdit();
        vm.chooseProtocol = chooseProtocol;
        vm.removeProtocol = removeProtocol;

        activate();

        function activate() {
            CampaignPrescriptionsService.cancel(); // this removes any errant state

            registerObserverCallbacks();

            displayBusyIndicator();

            configureChooserTabState();
            configureCampaignExercisesConfig();
            configureCampaignExerciseTemplatesExercisesConfig();
            configureCampaignProtocolExercisesConfig();

            vm.prescriptionsCrud.query(campaignId, vm.episodeModel.id).then(function (result) {
                vm.prescriptions = result.items;
            }, function (err) {
                RestResources.reportRestError(CampaignConstants.prescription.getAll.errorString, err);
            }).finally(function () {
                hideBusyIndicator();
            });
        }

        function canAddNewPrescription () {
            return !CampaignPrescriptionsService.isEdit();
        }

        function configureChooserTabState() {
            vm.tabState = {
                campaignExercises: true,
                campaignPrescriptionExercises: false,
                campaignProtocolExercises: false
            };
        }

        /**
         * This function displays the modal.
         *
         * @param {Object} event - the event object
         * @param {Object} item - the item that prompted the display
         * @returns {undefined}
         */
        function displayExerciseQuickViewModal (event, item) {
            /**
             * The callback function is used to determine what should be done when one of the valid targets is selected.
             *
             * @param {type} result - the selected target for the exercise
             * @returns {undefined}
             */
            var callback = function (/*result*/) {
                addSelectedPrescriptionExercise(item);
            };

            Utilities.modalExerciseQuickView(event, item, callback, retrieveValidTargets);
        }

        function addSelectedPrescriptionExercise (item) {
            var selectedItem = angular.copy(item);
            selectedItem.exercise = {
                name: item.name,
                title: item.title,
                thumbnail: item.thumbnail,
                thumbnailUrl: item.thumbnailUrl,
                reportOnly: item.reportOnly,
                id: item.id
            };

            selectedItem._id = _.uniqueId();

            ObserverService.notifyObservers(CampaignConstants.observers.prescription.quickAdd, [selectedItem]);
        }

        /**
         * This function is used to quick add exercises to patient prescriptions.
         * There should always be exactly one patient prescription in the view.
         *
         * @param {Object} event - the event object
         * @param {Object} item - the item that prompted the display
         */
        function quickAddExercises(event, item) {
            event.stopPropagation();

            if (retrieveValidTargets().length === 1) {
                addSelectedPrescriptionExercise(item);
            }
        }

        function quickAddExerciseTemplate (event, item) {
            event.stopPropagation();

            if (retrieveValidTargets().length === 1) {
                addSelectedExerciseTemplate(item);
            }
        }

        function addSelectedExerciseTemplate(item) {
            ObserverService.notifyObservers(CampaignConstants.observers.prescription.quickAdd, item.exerciseTemplates);
        }

        /*
         * The retrieveValidTargets function is used to determine which items an item could be added to.
         *
         * @returns {Array} targets - valid targets for an exercise
         */
        function retrieveValidTargets () {
            var targets = [];

            var newPrescriptionIndex = -1;
            var editId = CampaignPrescriptionsService.getEditId();

            for (var i = 0; i < vm.prescriptions.length; i++) {
                if (vm.prescriptions[i].id === editId || vm.prescriptions[i]._id === editId) {
                    newPrescriptionIndex = i;
                    break;
                }
            }

            if (newPrescriptionIndex !== -1) {
                targets.push(vm.prescriptions[newPrescriptionIndex]);
            }

            return targets;
        }

        function configureCampaignExercisesConfig () {
            vm.exercisesConfig.enableDragMode();
            vm.exercisesConfig.setCustomLayout('grid');
            vm.exercisesConfig.setGetLinkFn(undefined);

            vm.exercisesConfig.setQuickAddEnabled(true);
            vm.exercisesConfig.setQuickAddFn(quickAddExercises);

            vm.exercisesConfig.setQuickViewEnabled(true);
            vm.exercisesConfig.setQuickViewFn(displayExerciseQuickViewModal);

            vm.exercisesConfig.sortListeners = getCampaignExercisesConfigSortListeners();

            vm.exercisesConfig.maintainState($scope);
        }

        function configureCampaignExerciseTemplatesExercisesConfig () {
            vm.exerciseTemplatesConfig.enableDragMode();

            vm.exerciseTemplatesConfig.setQuickAddEnabled(true);
            vm.exerciseTemplatesConfig.setQuickAddFn(quickAddExerciseTemplate);

            // TODO where to get this? vm.execiseTemplatesConfig.templateUrl = '/app/research/exercise-templates/item-chooser-templates.tpl.html';
            vm.exerciseTemplatesConfig.sortListeners = getCampaignExerciseTemplatesExercisesConfigSortListeners();

            vm.exerciseTemplatesConfig.maintainState($scope);
        }

        function configureCampaignProtocolExercisesConfig () {
            var episode = vm.episodeModel;
            var rxTemplates = episode.protocol && episode.protocol.prescriptionTemplates ? Utilities.deepCopy(episode.protocol.prescriptionTemplates) : [];

            vm.campaignProtocolExercisesConfig = PrescriptionChooserConfig.init(rxTemplates, episode.protocol);
            vm.campaignProtocolExercisesConfig.enableDragMode();

            vm.campaignProtocolExercisesConfig.setQuickAddEnabled(true);
            vm.campaignProtocolExercisesConfig.setQuickAddFn(quickAddProtocolExercises);

            vm.campaignProtocolExercisesConfig.sortListeners = getCampaignProtocolExercisesConfigSortListeners();

            if (vm.campaignProtocolExercisesConfig.protocol) {
                setActiveConfig('campaignProtocolExercises');
            }

            vm.campaignProtocolExercisesConfig.maintainState($scope);
        }

        function setActiveConfig(activeConfigName) {
            var config = vm[activeConfigName + 'Config'];

            for (var key in vm.tabState) {
                vm.tabState[key] = false;
            }

            vm.tabState[activeConfigName] = true;
            config.nextPage();

            $rootScope.$broadcast("tabStateUpdated");
        }

        /**
         * This function is used to quick add protocols to patient prescriptions.
         * There should always be exactly one patient prescription in the view.
         *
         * @param {Object} event - the event object
         * @param {Object} item - the item that prompted the display
         */
        function quickAddProtocolExercises (event, item) {
            event.stopPropagation();

            if (retrieveValidTargets().length === 1) {
                addSelectedPrescriptionProtocol(item);
            }
        }

        /**
         * This function adds the selected protocol to the available prescription.
         *
         * @param {object} item - the selected protocol
         */
        function addSelectedPrescriptionProtocol (item) {
            ObserverService.notifyObservers(CampaignConstants.observers.prescription.quickAdd, item.exerciseTemplates);
            ObserverService.notifyObservers(CampaignConstants.observers.prescription.updateProtocolDetails, item);
        }

        function addNewPrescription () {
            vm.prescriptions.push({
                _expanded: true,
                _id: 'new', // only one can exist at a time, so we don't need a unique id
                frequency: Frequencies[0],
                prescriptionExercises: []
            });

            ObserverService.notifyObservers(CampaignConstants.observers.expanded.collapseAll, angular.noop);
        }

        function registerObserverCallbacks() {
            ObserverService.registerObserverCallback(CampaignConstants.observers.prescription.cancelPrescriptionCreation, cancelPrescriptionCreation);
            ObserverService.registerObserverCallback(CampaignConstants.observers.prescription.edit, edit);
            ObserverService.registerObserverCallback(CampaignConstants.observers.prescription.cancel, cancel);
            ObserverService.registerObserverCallback(CampaignConstants.observers.prescription.remove, removePrescription);
            ObserverService.registerObserverCallback(CampaignConstants.observers.prescriptions.reset, reset);
        }

        function cancelPrescriptionCreation() {
            _.remove(vm.prescriptions, function (p) {
                return 'new' === p._id;
            });

            cancel();
        }

        function removePrescription (prescription) {
            _.remove(vm.prescriptions, function (p) {
                return prescription.id === p.id;
            });
        }

        // uses a promise to display the busy indicator
        function displayBusyIndicator () {
            EpisodeTemplateService.displayBusyIndicator();
        }

        // clears the promise so that the busy indicator will no longer be displayed
        function hideBusyIndicator () {
            EpisodeTemplateService.hideBusyIndicator();
        }

        function edit() {
            isEdit(true);
        }

        function cancel() {
            isEdit(false);
        }

        /**
         * Updates the isEdit value with any value passed, and returns the current value.
         *
         * @param {Boolean} val - if sent, sets the isEdit value
         * @returns {Boolean} the current value of isEdit
         */
        function isEdit (val) {
            if (val === true || val === false) {
                vm.isEdit = val;
            }

            return vm.isEdit;
        }

        function reset () {
            displayBusyIndicator();

            vm.prescriptionsCrud.query(campaignId, vm.episodeModel.id).then(function (result) {
                vm.prescriptions = result.items;

                isEdit(false);
            }, function (err) {
                RestResources.reportRestError(CampaignConstants.campaignPrescriptions.getAll.errorString, err);
            }).finally(function () {
                hideBusyIndicator();
            });
        }

        function chooseProtocol() {
            vm.protocolsConfig.setSelectedFn(function(protocol) {
                displayBusyIndicator();

                EpisodeTemplatesService.get(vm.clinic.id, campaignId, vm.episodeModel.id).then(function (result) {
                    angular.extend(result, {
                        protocol: protocol
                    });

                    EpisodeTemplatesService.update(vm.clinic.id, campaignId, vm.episodeModel.id, result).then(function () {
                        vm.episode.protocol = protocol;
                        configureCampaignProtocolExercisesConfig();
                    }, function(err) {
                        RestResources.reportRestError(err);
                    }).finally(function () {
                        hideBusyIndicator();
                    });
                });
            });

            vm.protocolsConfig.maintainState($scope);

            IhhModalItemChooser.open(vm.protocolsConfig, true);
        }

        function getCampaignProtocolExercisesConfigSortListeners () {
            return {
                dragStart: function( /*event*/ ) {
                    dragChecker.bindEvents();
                },
                itemMoved: function(event) {
                    dragChecker.unbindEvents();

                    if (dragChecker.isOverDest()) {
                        var sourceItem = event.source.itemScope.modelValue;

                        ObserverService.notifyObservers(CampaignConstants.observers.prescription.quickAddWithIndex, {
                            exerciseTemplates: sourceItem.exerciseTemplates,
                            index: event.dest.index
                        });
                        ObserverService.notifyObservers(CampaignConstants.observers.prescription.updateProtocolDetails, sourceItem);
                    }
                    _.remove(event.dest.sortableScope.modelValue, function(val) {
                        return !val.hasOwnProperty('exercise');
                    });
                },
                dragMove: SortableHelper.dragMove,
                longTouch: true,
                containment: '#sortable-container',
                clone: true,
                additionalPlaceholderClass: AdditionalPlaceholderClasses
            };
        }

        function getCampaignExerciseTemplatesExercisesConfigSortListeners () {
            return {
                dragStart: function( /*event*/ ) {
                    dragChecker.bindEvents();
                },
                itemMoved: function(event) {
                    dragChecker.unbindEvents();
                    if (dragChecker.isOverDest()) {
                        var sourceItem = event.source.itemScope.modelValue;

                        ObserverService.notifyObservers(CampaignConstants.observers.prescription.quickAddWithIndex, {
                            exerciseTemplates: sourceItem.exerciseTemplates,
                            index: event.dest.index
                        });
                    }

                    _.remove(event.dest.sortableScope.modelValue, function(val) {
                        return !val.hasOwnProperty('exercise');
                    });
                },
                dragMove: SortableHelper.dragMove,
                longTouch: true,
                containment: '#sortable-container',
                clone: true,
                additionalPlaceholderClass: AdditionalPlaceholderClasses
            };
        }

        function getCampaignExercisesConfigSortListeners() {
            return {
                accept: function() {
                    return false;
                },
                dragStart: function( /*event*/ ) {
                    dragChecker.bindEvents();
                },
                itemMoved: function(event) {
                    dragChecker.unbindEvents();

                    if (dragChecker.isOverDest()) {
                        var sourceItem = event.source.itemScope.modelValue;
                        var exerciseTemplate = {
                            exercise: angular.copy(sourceItem)
                        };

                        ObserverService.notifyObservers(CampaignConstants.observers.prescription.quickAddWithIndex, {
                            exerciseTemplates: [exerciseTemplate],
                            index: event.dest.index
                        });
                    }

                    _.remove(event.dest.sortableScope.modelValue, function(val) {
                        return !val.hasOwnProperty('exercise');
                    });
                },
                dragMove: SortableHelper.dragMove,
                longTouch: true,
                containment: '#sortable-container',
                clone: true,
                additionalPlaceholderClass: AdditionalPlaceholderClasses
            };
        }

        function removeProtocol() {
            displayBusyIndicator();

            EpisodeTemplatesService.get(vm.clinic.id, campaignId, vm.episodeModel.id).then(function (result) {
                delete result.protocol;

                EpisodeTemplatesService.update(vm.clinic.id, campaignId, vm.episodeModel.id, result).then(function (/*updateResult*/) {
                    delete vm.episode.protocol;
                    configureCampaignProtocolExercisesConfig();
                }, function(err) {
                    RestResources.reportRestError(CampaignConstants.protocol.remove.errorString, err);
                }).finally(function () {
                    hideBusyIndicator();
                });
            });
        }
    }
})();
